import ReviewerRole from './ReviewerRole'

export default class UnsetReviewer extends ReviewerRole {
  arcDownloadsPerWeek: number = 0
  totalClaimOverdueDayAllowance: number = 0
  arcMaxDownloads: number = 0
}
